import { useState } from 'react';
import { ui } from '../ui';
import { ApiError, useApiMutation } from '../api';

export interface CreemSyncSkip {
  productId: string;
  productName: string;
  currency: string | null;
  reason: string;
}

export interface CreemSyncReport {
  created: number;
  updated: number;
  archived: number;
  unchanged: number;
  skipped: CreemSyncSkip[];
  notSellable: CreemSyncSkip[];
}

export function CreemSync({ path, hint }: { path: string; hint: string }): React.ReactElement {
  const call = useApiMutation();
  const [busy, setBusy] = useState(false);
  const [message, setMessage] = useState<string | null>(null);
  const [report, setReport] = useState<CreemSyncReport | null>(null);

  async function send(): Promise<void> {
    setBusy(true);
    setMessage(null);
    setReport(null);
    try {
      const answer = await call<{ ok: string; report: CreemSyncReport }>(path, { method: 'POST' });
      setMessage(answer.ok);
      setReport(answer.report);
    } catch (error) {
      setMessage(error instanceof ApiError ? error.message : 'That did not work. Try again.');
    } finally {
      setBusy(false);
    }
  }

  const reasons = report ? [...report.notSellable, ...report.skipped] : [];

  return (
    <section className={ui.stack ?? ''}>
      <h2 className={ui.sectionTitle ?? ''}>Creem</h2>

      <p className={ui.statLabel ?? ''}>{hint}</p>

      <div className={ui.actions ?? ''}>
        <button
          type="button"
          className={ui.buttonSecondary ?? ''}
          disabled={busy}
          onClick={() => void send()}
        >
          {busy ? 'Sending…' : 'Send to Creem'}
        </button>
      </div>

      {message ? (
        <p className="gb-body" role="status">
          {message}
        </p>
      ) : null}

      {reasons.length > 0 ? (
        <ul className="gb-body">
          {reasons.map((entry, index) => (
            <li key={`${entry.productId}-${entry.currency ?? 'all'}-${index}`}>
              <strong>{entry.productName}</strong>
              {entry.currency ? ` (${entry.currency})` : ''} — {entry.reason}
            </li>
          ))}
        </ul>
      ) : null}
    </section>
  );
}
